import React from "react";
import ConfiguracaoInstituicaoProvidenceForm from "./ConfiguracaoInstituicaoProvidenceForm";

const ConfiguracaoInstituicaoProvidenceContainer = () => {
  return <ConfiguracaoInstituicaoProvidenceForm />;
};

export default ConfiguracaoInstituicaoProvidenceContainer;
